import { Button, DatePicker, Form, Input, InputNumber, Select } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs'
import axiosInstance from "../common/api";
import { requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";

export default function () {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const onFinish = (form) => {
        setLoading(true);
        axiosInstance
            .post("charge", form)
            .then(({ data }) => navigate(`/charges/${data.id}`, { replace: true }))
            .finally(() => setLoading(false));
    };

    return (
        <Form layout="vertical" onFinish={onFinish}>
            <Form.Item name="employee" label="Dipendente" rules={[requiredField]}>
                <DebounceSelect
                    labelInValue={false}
                    fetchOptions={(query) =>
                        axiosInstance
                            .get("employeeCompact", {
                                params: {
                                    startDate: "1900-01-01",
                                    endDate: "9999-01-01",
                                    query,
                                },
                            })
                            .then(({ data }) =>
                                data.map((x) => ({
                                    label: x.fullName,
                                    value: x.id,
                                })),
                            )
                    }
                />
            </Form.Item>
            <Form.Item name="description" label="Descrizione" rules={[requiredField]}>
                <Input />
            </Form.Item>
            <Form.Item
                name="date"
                label="Data"
                rules={[requiredField]}
                getValueProps={(value) => ({ value: value && dayjs(value) })}
                normalize={(value) => value && value.format("YYYY-MM-DD")}
            >
                <DatePicker format="DD/MM/YYYY" />
            </Form.Item>
            <Form.Item label="Importo" name="amount" rules={[requiredField]}>
                <InputNumber decimalSeparator="," precision={2} controls={false} />
            </Form.Item>
            <Form.Item style={{ textAlign: "end" }}>
                <Button loading={loading} htmlType="submit" type="primary">
                    Conferma
                </Button>
            </Form.Item>
        </Form>
    );
}
